export interface SystemLastUpdatedLike {
  last_updated?: string;
  last_updated_time?: string;
}

export function getSystemLastUpdatedValue(
  system: SystemLastUpdatedLike,
): string | undefined {
  return system.last_updated ?? system.last_updated_time;
}

export function getSystemLastUpdatedTimestamp(
  system: SystemLastUpdatedLike,
): number {
  const value = getSystemLastUpdatedValue(system);
  const timestamp = value ? new Date(value).getTime() : 0;
  // An unparseable value sorts as oldest instead of poisoning comparisons with NaN.
  return Number.isFinite(timestamp) ? timestamp : 0;
}
